import React, { useEffect } from "react";

import Main from "./components/Main";

import { AuthProvider } from "contexts/auth";
import { UserProvider } from "contexts/user";

const App = props => {
  useEffect(() => {
    localStorage.setItem("STRIPE_PK", props.stripe_pk);
  }, []);

  return (
    <AuthProvider>
      <UserProvider>
        <Main {...props} />
      </UserProvider>
    </AuthProvider>
  );
};

export default App;
